import React from "react";

import { IonGrid, IonRow, IonCol, IonIcon } from "@ionic/react";

import {
  informationCircle,
  checkmarkCircle,
  happy,
  closeCircle
} from "ionicons/icons";

import "./status.css";

interface StatusProps {
  type: number;
}

type statusOptions = {
  [key: string]: string;
};

const StatusTypesText: statusOptions = {
  1: "Aguardando confirmação",
  2: "Cancelado",
  3: "Confirmada",
  4: "Finalizada"
};

const StatusTypesColor: statusOptions = {
  1: "warning",
  2: "danger",
  3: "success",
  4: "primary"
};

const Status: React.FC<StatusProps> = ({ type }) => {
  return (
    <IonGrid>
      <IonRow className="ion-justify-content-center">
        <IonCol size="12">
          <div className="passage-status" color={StatusTypesColor[type]}>
            {type === 1 ? (
              <IonIcon
                className="icon"
                color={StatusTypesColor[type]}
                icon={informationCircle}
              />
            ) : null}
            {type === 2 ? (
              <IonIcon
                className="icon"
                color={StatusTypesColor[type]}
                icon={closeCircle}
              />
            ) : null}
            {type === 3 ? (
              <IonIcon
                className="icon"
                color={StatusTypesColor[type]}
                icon={checkmarkCircle}
              />
            ) : null}
            {type === 4 ? (
              <IonIcon
                className="icon"
                color={StatusTypesColor[type]}
                icon={happy}
              />
            ) : null}
            <span>{StatusTypesText[type]}</span>
          </div>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default Status;
